<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="shadow-lg">
          <div class="row content-add-btn">
            <button class="btn btn-secondary" @click="$router.go(-1)">
              <em class="fa fa-chevron-left"></em>
              {{ $t('common_words.exit') }}
            </button>
          </div>
          <hr />
          <form-wizard
            ref="formWizard"
            v-if="this.isCreate() || this.isUpdate()"
            @on-complete="storeUpdateRole"
            title
            subtitle
            :back-button-text="$t('common_words.back')"
            :next-button-text="$t('common_words.next')"
            :finish-button-text="$t('common_words.save')"
            class="custom-padding-wz-header"
          >
            <tab-content
              :title="$t('common_words.general_information')"
              :before-change="() => validateStep('firstStep')"
            >
              <first-step
                ref="firstStep"
                @on-validated="onStepValidated"
                @fillRoleForm="fillRoleForm"
                @showHideLoading="showHideLoading"
              ></first-step>
            </tab-content>
            <tab-content
              :title="$t('common_words.modules')"
              :before-change="() => validateStep('secondStep')"
            >
              <second-step
                ref="secondStep"
                @on-validated="onStepValidated"
                @fillRoleForm="fillRoleForm"
                @showHideLoading="showHideLoading"
              ></second-step>
            </tab-content>
            <tab-content
              :title="$t('common_words.permits')"
              :before-change="() => validateStep('thirdStep')"
            >
              <third-step
                ref="thirdStep"
                @on-validated="onStepValidated"
                @fillRoleForm="fillRoleForm"
                @showHideLoading="showHideLoading"
                :type="roleForm.type"
                :selected_modules="roleForm.modules"
              ></third-step>
            </tab-content>
            <tab-content :title="$t('common_words.confirm')">
              <p class="cm-mg-p-wzd text-center text-muted">
                4.1 {{ $t('common_words.verify_inputed_information') }}
              </p>
              <br />
              <div class="row d-flex justify-content-center">
                <div class="col-9">
                  <table class="table">
                    <tbody>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.name') }}:</strong>
                          </h6>
                          {{ roleForm.name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.type_user') }}:</strong>
                          </h6>
                          {{ roleForm.type }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{
                                $t('common_words.associated_modules2')
                              }}:</strong
                            >
                          </h6>
                          <span
                            v-for="(mod, index) in roleForm.name_modules"
                            :key="index"
                          >
                            <el-tag type="info">{{ mod }}</el-tag>
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{
                                $t('common_words.associated_permissions')
                              }}:</strong
                            >
                          </h6>
                          <div class="row">
                            <div class="col-4">
                              <blockquote>
                                <h5>{{ $t('common_words.globals') }}</h5>
                                <el-tree
                                  :data="roleForm.selected_general_permissions"
                                  show-checkbox
                                  node-key="id"
                                  :default-checked-keys="
                                    roleForm.general_permissions
                                  "
                                  default-expand-all
                                  :props="{
                                    children: 'children',
                                    label: 'label',
                                    disabled: 'disabled',
                                  }"
                                >
                                </el-tree>
                              </blockquote>
                            </div>
                            <div class="col-8">
                              <blockquote>
                                <h5>{{ $t('common_words.specifics') }}</h5>
                                <el-tree
                                  :data="roleForm.selected_specific_permissions"
                                  show-checkbox
                                  node-key="id"
                                  :default-checked-keys="
                                    roleForm.specific_permissions
                                  "
                                  :props="{
                                    children: 'children',
                                    label: 'label',
                                    disabled: 'disabled',
                                  }"
                                >
                                </el-tree>
                              </blockquote>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{
                                $t('common_words.associated_companies')
                              }}:</strong
                            >
                          </h6>
                          <span
                            v-for="(
                              business, index
                            ) in roleForm.name_businesses"
                            :key="index"
                          >
                            <el-tag type="info">{{ business }}</el-tag>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </tab-content>
          </form-wizard>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('vie.Pag.Das.Bus.Rol.RoleCreateEdit.text2') }}
            </h5>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { showContinue } from 'src/util/Util.js';
import { Tree } from 'element-ui';
import FirstStep from './Steps/FirstStep.vue';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './Steps/SecondStep.vue';
import ThirdStep from './Steps/ThirdStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    [Tree.name]: Tree,
  },

  data() {
    return {
      title: '',
      roleForm: {
        type: 'usuario',
      },
      wizardModel: {},
    };
  },

  mixins: [MixinPermissions, MixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        name: null,
        businesses_ids: null,
        type: 'usuario',
      };
      this.$refs.secondStep.model = {
        modules: [],
      };
      this.$refs.thirdStep.model = {
        general_permissions: [],
        specific_permissions: [],
        selected_general_permissions: [],
        selected_specific_permissions: [],
      };
      this.$refs.thirdStep.setCheckedKeysTree('');
      this.roleForm = {
        type: 'usuario',
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillRoleForm(ref, others) {
      this.roleForm = Object.assign({}, this.roleForm, this.$refs[ref].model);
      if (others) {
        this.roleForm = Object.assign({}, this.roleForm, others);
      }
    },

    storeUpdateRole() {
      this.showHideLoading(true);
      this.roleForm.route = 'roles';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.roleForm.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.roleForm)
            .then((response) => {
              this.showHideLoading();
              this.forceRenderMenu();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/roles',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.roleForm)
            .then((response) => {
              this.showHideLoading();
              this.forceRenderMenu();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/roles',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('roles');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('roles');
  },
};
</script>
